export default function FooterPartener(){
    return(
        <footer className="footer-defile">
            <p className="text-center c-white" style={{fontSize: '0.6em'}}>
                Collaborators
            </p>
            <img src="./assets/footer_static.png" width={'100%'} alt="footer" />
            <p className="text-center c-white mb-3" style={{fontSize: '0.6em'}}>
                Sponsored by
            </p>
            <div style={{width: '100%', height: (window.innerWidth / 10,38) + 'px', overflow: 'hidden'}} className="defile">

            </div>
        </footer>
    )
}